import { createContext, ReactNode, useMemo } from "react";

export const SkeletonContext = createContext<
  | {
      isLoading: boolean;
    }
  | undefined
>(undefined);

export const SkeletonContextProvider = ({
  children,
  isLoading,
}: {
  children: ReactNode;
  isLoading: boolean;
}) => {
  const providerValue = useMemo(() => ({ isLoading }), [isLoading]);

  return (
    <SkeletonContext.Provider value={providerValue}>
      {children}
    </SkeletonContext.Provider>
  );
};
